import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';

import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import engineApiSlice from 'src/shared/state/api-slices/engineApiSlice';
import riskMaterialityCmsSlice from 'src/shared/state/api-slices/riskMaterialityCmsSlice';

import config from 'src/config';
import type { DeepPartial } from 'src/shared/types';
import createRootReducer from './root/rootReducer';

const rootReducer = createRootReducer();

const middleware = [graphApiSlice.middleware, engineApiSlice.middleware, riskMaterialityCmsSlice.middleware];

export default function getReduxStore() {
    const store = configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middleware),
        devTools: config.isDevelopment,
    });

    return store;
}

export type AppStore = ReturnType<typeof getReduxStore>;
export type RootState = ReturnType<typeof rootReducer>;
export type PartialRootState = DeepPartial<RootState>;
export type AppDispatch = AppStore['dispatch'];
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
